import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

// Authentication
import LoginReducer from "./auth/login/reducer";
import AccountReducer from "./auth/register/reducer";
import ProfileReducer from "./auth/profile/reducer";

import BuildingsReducer from './buildings/reducer'
import clientsReducer from './clients/reducer'
import clientStatsReducer from './clientStats/reducer'
import contractReducer from './contracts/reducer'
import contractStatsReducer from './contractStats/reducer'
import paymentReducer from './payments/reducer'
import phasesReducer from './phases/reducer'
import projectReducer from './project/reducer'
import settlementPriceReducer from './settelmentPrices/reducer'
import unitReducer from './units/reducer'
import ModalReducer from "./modal/reducer"

//User
import userReducer from './user/reducer'
import accountsReducer from './accounts/reducer'

//Reporting
import ReportReducer from './report/reducer'
import EmailReducer from './email/reducer'

import SmartBillReducer from './smartbill/reducer'
import InvoiceReducer from './invoices/reducer'
import VendorInvoiceReducer from './vendorInvoices/reducer'
import VendorInvoiceConfigReducer from './vendorInvoiceConfig/reducer'
import notificationReducer from './notifications/reducer'

const rootReducer = combineReducers({
    Layout: LayoutReducer,
    Login: LoginReducer,
    Account: AccountReducer,
    Profile: ProfileReducer,
    User: userReducer,
    Accounts: accountsReducer,
    ReportReducer: ReportReducer,
    Buildings: BuildingsReducer,
    Clients: clientsReducer,
    ClientStats: clientStatsReducer,
    Contract: contractReducer,
    ContractStats: contractStatsReducer,
    Payment: paymentReducer,
    Phases: phasesReducer,
    Project: projectReducer,
    SettlementPrices: settlementPriceReducer,
    Unit: unitReducer,
    Modal: ModalReducer,
    Email: EmailReducer,
    SmartBill: SmartBillReducer,
    Invoices: InvoiceReducer,
    VendorInvoices: VendorInvoiceReducer,
    VendorInvoiceConfig: VendorInvoiceConfigReducer,
    Notification: notificationReducer,
});

export default rootReducer;
